export var FORM_MODE;
(function (FORM_MODE) {
    FORM_MODE["EDIT"] = "EDIT";
    FORM_MODE["ADD"] = "ADD";
})(FORM_MODE || (FORM_MODE = {}));
export var COUNTRIES;
(function (COUNTRIES) {
    COUNTRIES["US"] = "US";
})(COUNTRIES || (COUNTRIES = {}));
export var PHONE_TYPES;
(function (PHONE_TYPES) {
    PHONE_TYPES["UNKNOWN"] = "UNKNOWN";
})(PHONE_TYPES || (PHONE_TYPES = {}));
export var ADDRESS_TYPES;
(function (ADDRESS_TYPES) {
    ADDRESS_TYPES["SHIPPING"] = "SHIPPING";
})(ADDRESS_TYPES || (ADDRESS_TYPES = {}));
export var YES_NO_FLAGS;
(function (YES_NO_FLAGS) {
    YES_NO_FLAGS["YES"] = "Y";
    YES_NO_FLAGS["NO"] = "N";
})(YES_NO_FLAGS || (YES_NO_FLAGS = {}));
